// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.dp__input {\n  background-color: transparent !important;\n  border: none !important;\n}\n.dp__input_icons {\n  height: 24px !important;\n  width: 24px !important;\n  left: -5px !important;\n}\n.dp__input_icon_pad {\n  padding-left: 2.3rem !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
